import {
	INIT_REQUEST,
	REQUEST_FETCHING,
	REQUEST_FAILURE,
	REQUEST_SUCCESS,
	SET_REQUEST,
	SET_REQUEST_META,
	SET_PAGE_LIMIT,
	SET_ORDER_BY,
	SET_PAGE,
	INCREMENT_PAGE,
	DECREMENT_PAGE,
	SET_QUERY_FILTERS,
	UNSET_QUERY_FILTERS,
	UNSET_QUERY_FILTER,
	SET_REQUEST_SINGLE
} from "@stofloos/actions/requests";

const initialState = {};

const requests = (state = initialState, action) => {
	switch (action.type) {
		case INIT_REQUEST:
			return {
				...state,
				[action.requestId]: {
					endpoint: action.endpoint,
					isFetching: false,
					isFailure: false,
					isSuccess: false,
					single: false,
					page: 1,
					totalPages: undefined,
					pageLimit: action.pageLimit,
					hasMorePages: false,
					queryFilters: []
				}
			};
		case SET_REQUEST_SINGLE:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					single: action.single
				}
			};
		case SET_REQUEST:
			return {
				...state,
				[action.requestId]: {
					isFetching: action.isFetching,
					isFailure: action.isFailure,
					isSuccess: action.isSuccess,
					page: action.page,
					pageLimit: action.pageLimit
				}
			};
		case SET_REQUEST_META:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					hasMorePages: state[action.requestId].page < action.totalPages,
					totalPages: action.totalPages ? action.totalPages : undefined,
					totalObjects: action.totalObjects ? action.totalObjects : undefined,
					objectId: action.objectId ? action.objectId : undefined
				}
			};
		case SET_QUERY_FILTERS:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					queryFilters: action.updatedQueryFilters
				}
			};
		case UNSET_QUERY_FILTERS:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					queryFilters: undefined
				}
			};
		case UNSET_QUERY_FILTER:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					queryFilters: state[action.requestId].queryFilters.filter((item, index) => index !== action.index)
				}
			};
		case SET_ORDER_BY:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					orderBy: {
						direction: action.direction,
						column: action.column,
						cast: action.cast
					}
				}
			};
		case SET_PAGE:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					page: action.page
				}
			};
		case INCREMENT_PAGE:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					page: state[action.requestId].page + 1,
					hasMorePages: state[action.requestId].page < state[action.requestId].totalPages
				}
			};
		case DECREMENT_PAGE:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					page: state[action.requestId].page - 1,
					hasMorePages: state[action.requestId].page < state[action.requestId].totalPages
				}
			};
		case SET_PAGE_LIMIT:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					pageLimit: action.pageLimit
				}
			};
		case REQUEST_FETCHING:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					isFetching: true,
					isFailure: false,
					isSuccess: false,
					message: action.message ? action.message : ""
				}
			};
		case REQUEST_FAILURE:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					isFetching: false,
					isFailure: true,
					isSuccess: false,
					message: action.message
				}
			};
		case REQUEST_SUCCESS:
			return {
				...state,
				[action.requestId]: {
					...state[action.requestId],
					isFetching: false,
					isFailure: false,
					isSuccess: true,
					message: action.message ? action.message : ""
				}
			};
		default:
			return state;
	}
};

export default requests;
